<div class="new-reservation-dialog__attendee-picker">
  <cue-button
    btnClass="small"
    type="secondary"
    [icon]="icons.cueAdd"
    (click)="onOpenPicker($event)"
    [smallResponsive]="true"
  >
    {{ translation.newReservationUi.administration.addAttendee | transloco }}
  </cue-button>

  @if (active()) {
    <assist-attendees-dropdown
      class="new-reservation-dialog__attendee-picker-control"
      [preferEmail]="true"
      [ignoreTimes]="true"
      [value]="value()"
      (valueChange)="valueChange.emit($event)"
      (filterValueChange)="filterValueChange.emit($event)"
    />

    @if (customEmail(); as email) {
      <cue-button
        btnClass="small"
        type="secondary"
        [icon]="icons.cueAdd"
        class="new-reservation-dialog__attendee-custom-email"
        (click)="onAddCustomEmail($event, email)"
        [smallResponsive]="true"
      >
        {{ translation.newReservationUi.administration.addEmailAttendee | transloco: { email } }}
      </cue-button>
    }
  }
</div>
